import React, { useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import axios from 'axios';
import config from '../../config';
import { NdoeImage } from '../../components/ndoe';
import './ventesClienteModal.css';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
const $ = (n) => `${Math.round(Number(n) || 0).toLocaleString('fr-FR')} $`;
const dateFr = (v) => {
  const [y, m, j] = String(v || '').slice(0, 10).split('-');
  return j ? `${j}/${m}/${y}` : v;
};

/**
 * Drill-down « Recettes par cliente » (demande proprio 20/07) : au clic sur une
 * cliente du tableau de bord, le détail de ce qu'elle a acheté sur la fenêtre —
 * article × quantité, prix, photo miniature, total. Partagé par les dashboards
 * admin et secrétaire (mêmes données, même garde finance côté serveur).
 */
export default function VentesClienteModal({ open, onClose, idClient, nom, start, end }) {
  const [etat, setEtat] = useState({ loading: true, lignes: [], total: 0, paires: 0, erreur: '' });

  useEffect(() => {
    if (!open || !idClient) return undefined;
    let alive = true;
    setEtat({ loading: true, lignes: [], total: 0, paires: 0, erreur: '' });
    axios.get(`${DOMAIN}/api/dashboard/ventes-cliente`, { params: { id_client: idClient, start, end } })
      .then(({ data }) => {
        if (!alive) return;
        setEtat({ loading: false, lignes: data.lignes || [], total: data.total || 0, paires: data.paires || 0, erreur: '' });
      })
      .catch((e) => {
        if (!alive) return;
        setEtat({ loading: false, lignes: [], total: 0, paires: 0, erreur: e.response?.data?.error || 'Chargement impossible.' });
      });
    return () => { alive = false; };
  }, [open, idClient, start, end]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={560}
      title={`Ventes — ${nom || 'cliente'} (${dateFr(start)}${start !== end ? ` → ${dateFr(end)}` : ''})`}
      destroyOnClose
    >
      {etat.loading ? (
        <div className="vcm-chargement"><Spin /></div>
      ) : etat.erreur ? (
        <p className="vcm-vide">{etat.erreur}</p>
      ) : !etat.lignes.length ? (
        <p className="vcm-vide">Aucune vente confirmée sur cette fenêtre.</p>
      ) : (
        <>
          <div className="vcm-lignes">
            {etat.lignes.map((l, i) => (
              <div className="vcm-ligne" key={i}>
                <NdoeImage src={l.img} alt={l.nom_produit || 'Article'} size="sm" />
                <div className="vcm-ligne__txt">
                  <b>{l.nom_produit}</b>
                  <small>
                    {[l.taille ? `P${l.taille}` : null, l.couleur].filter(Boolean).join(' · ')}
                    {start !== end ? ` · ${dateFr(l.jour)}` : ''}
                  </small>
                </div>
                <div className="vcm-ligne__num num">
                  <span>{l.quantite} × {$(l.prix_unitaire)}</span>
                  <b>{$(l.montant)}</b>
                </div>
              </div>
            ))}
          </div>
          <div className="vcm-total">
            <span>{etat.paires} paire(s)</span>
            <b className="num">{$(etat.total)}</b>
          </div>
        </>
      )}
    </Modal>
  );
}
